import React from 'react';
import {connect} from "react-redux";
import {showUpgradeModal as showSubscribeModal} from "../../Manage/actions";

const UpgradeBadge = ({ dispatch }) => {
  const onClick = () => {
    dispatch(showSubscribeModal(true))
    alert('clicked');
  }

  return <img className="ms-1" alt="Pro" src="assets/icons/pro-black.png" height="20" onClick={onClick} />
}

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(undefined, mapDispatchToProps)(UpgradeBadge);
